import { IconName } from "assets/icons/UnumSync";
import { metaInformation } from "../metaInformation";

export type navLink = {
  id: string;
  depth?: number;
  icon?: IconName;
  label: string;
  link: string;
} & metaInformation<"internal" | "external">;

export function isNavLink(item: any): item is navLink {
  return item?.type === "internal" || item?.type === "external";
}

export function isInternalNavLink(item: any): boolean {
  return item?.type === "internal";
}

export function isExternalNavLink(item: any): boolean {
  return item?.type === "external";
}
